import {
    Document,
    PDFViewer,
    Page as PDFPage,
    StyleSheet,
    Text as PDFText,
    View as PDFView,
    Image as PDFImage
} from '@react-pdf/renderer';

/* 🔹 STYLES */
const styles = StyleSheet.create({
    page: {
        position: 'relative'
    },

    container: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    },

    /* 🔹 FIELD POSITIONS - ADJUSTED BASED ON "NAME" REFERENCE */
    // Name field is at top: 185, left: 115 (this is your reference)

    serial: {
        position: 'absolute',
        top: 150,        // Above name field
        right: 30,     // Right aligned
        fontSize: 8,
        fontWeight: 'bold'
    },

    name: {
        position: 'absolute',
        top: 177,       // Reference position (KEEP AS IS)
        left: 90,      // Reference position (KEEP AS IS)
        fontSize: 8,
        fontWeight: 'bold'
    },

    ageSex: {
        position: 'absolute',
        top: 190,       // Same vertical level as name
        left: 290,      // To the right of name field
        fontSize: 8
    },

    date: {
        position: 'absolute',
        top: 177,       // Same vertical level as name
        left: 270,      // Further right
        fontSize: 8
    },

    uhid: {
        position: 'absolute',
        top: 173,       // Same vertical level as name
        left: 445,      // Rightmost position
        fontSize: 8
    },

    op_no: {
        position: 'absolute',
        top: 153,       // Below name (185 + 30px spacing)
        left: 410,      // Adjusted to match template alignment
        fontSize: 8
    },

    phone: {
        position: 'absolute',
        top: 204,       // Same vertical level as guardian
        left: 300,      // Right side
        fontSize: 8
    },

    address: {
        position: 'absolute',
        top: 206,       // Below guardian (215 + 30px spacing)
        left: 63,      // Aligned with name field
        fontSize: 8
    },

    consultant: {
        position: 'absolute',
        top: 187,
        left: 485,
        fontSize: 8
    },

    guardian_name: {
        position: 'absolute',
        top: 190,       // Below guardian (215 + 30px spacing)
        left: 98,      // Aligned with name field
        fontSize: 8
    },

    department: {
        position: 'absolute',
        top: 202,
        left: 465,
        fontSize: 9
    },

    patientDetailsLine: {
        position: 'absolute',
        top: 225, // Adjust vertical position as needed
         left: 1,
         right: 1,
        borderBottomWidth: 1,
        borderBottomColor: '#000',
    },
});

/* 🔹 MAIN COMPONENT */
export const PatientRegistrationPdf26 = ({ data }) => {
    function formatDate(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        const istParts = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Asia/Kolkata',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }).formatToParts(date);
        const day = istParts.find((p) => p.type === 'day').value;
        const month = istParts.find((p) => p.type === 'month').value;
        const year = istParts.find((p) => p.type === 'year').value;
        return `${day}/${month}/${year}`;
    }

    return (
        <PDFViewer width="100%" height="100%">
            <Document>
                <PDFPage size="A4" style={styles.page}>

                    {/* ✅ BACKGROUND TEMPLATE */}
                    <PDFImage
                        src={`${window.location.origin}/PDf Print Format.png`}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%'
                        }}
                        fixed
                    />

                    {/* ✅ OVERLAY VALUES */}
                    <PDFView style={styles.container}>

                        <PDFText style={styles.serial}>
                            {data?.token_no || ''}
                        </PDFText>

                        <PDFText style={styles.name}>
                            {data?.name || ''}
                        </PDFText>

                        <PDFText style={styles.ageSex}>
                            {data?.age || ''}/{data?.gender || ''}
                        </PDFText>

                        <PDFText style={styles.date}>
                            {formatDate(data?.reg_date) } -{ data?.reg_time || ''}
                        </PDFText>

                        <PDFText style={styles.uhid}>
                            {data?.uhid || ''}
                        </PDFText>

                        <PDFText style={styles.op_no}>
                            {data?.op_no || ''}
                        </PDFText>

                        <PDFText style={styles.phone}>
                            {data?.mobile || ''}
                        </PDFText>

                        <PDFText style={styles.address}>
                            {data?.address || ''}
                        </PDFText>



                        <PDFText style={styles.consultant}>
                            {data?.consultant || ''}
                        </PDFText>

                        <PDFText style={styles.guardian_name}>
                            {data?.guardian_name || ''}
                        </PDFText>

                        <PDFText style={styles.department}>
                            {data?.department || ''}
                        </PDFText>

                        <PDFView style={styles.patientDetailsLine} />



                    </PDFView>

                </PDFPage>
            </Document>
        </PDFViewer>
    );
};